export default __webpack_public_path__ + "static/media/logo_ots_rentacar.a1e3e58e.svg";